import apiClient from './api';

class PfpTrollyFloorLayoutService {
  // List available layouts
  async listLayouts() {
    try {
      const response = await apiClient.get('/pfp-floor-layout/list');
      return response.data;
    } catch (error) {
      console.error('Error listing floor layouts:', error);
      throw error;
    }
  }

  // Get a specific floor layout by id or name
  async getLayout(options?: { id?: number; name?: string }) {
    try {
      const response = await apiClient.get('/pfp-floor-layout', { params: options || {} });
      return response.data;
    } catch (error) {
      console.error('Error fetching floor layout:', error);
      throw error;
    }
  }

  // Save or update the floor layout
  async saveLayout(layoutData: {
    id?: number;
    name: string;
    gridRows: number;
    gridCols: number;
    slots: any[];
    cells: any[][];
  }) {
    try {
      console.log('[Floor Layout Service] Saving layout to:', apiClient.defaults.baseURL + '/pfp-floor-layout');
      console.log('[Floor Layout Service] Payload:', {
        name: layoutData.name,
        gridRows: layoutData.gridRows,
        gridCols: layoutData.gridCols,
        slotsCount: layoutData.slots?.length,
        cellsSize: layoutData.cells?.length + 'x' + layoutData.cells?.[0]?.length
      });
      
      const response = await apiClient.post('/pfp-floor-layout', layoutData);
      console.log('[Floor Layout Service] Save response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[Floor Layout Service] Save error:', {
        message: error?.message,
        status: error?.response?.status,
        data: error?.response?.data,
        url: error?.config?.url
      });
      throw error;
    }
  }

  // Reset floor layout to defaults
  async resetLayout() {
    try {
      const response = await apiClient.delete('/pfp-floor-layout');
      return response.data;
    } catch (error) {
      console.error('Error resetting floor layout:', error);
      throw error;
    }
  }

  // Delete a specific layout by id
  async deleteLayout(id: number) {
    try {
      const response = await apiClient.delete(`/pfp-floor-layout/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting floor layout:', error);
      throw error;
    }
  }
}

export default new PfpTrollyFloorLayoutService();
